require('./_wks-define')('asyncIterator');


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/core-js/library/modules/es7.symbol.async-iterator.js
 ** module id = 236
 ** module chunks = 1
 **/